import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ReceiptsService {

  constructor(private http: HttpClient) {

  }


  getListYears() {
    return this.http.get(`${environment.api_cm_receipts}/listYears`)
      .pipe(map(data => data));
  }

  getListMonth() {
    return this.http.get(`${environment.api_cm_receipts}/listMonth`)
      .pipe(map(data => data));
  }

  /**
   *
   * @param vendor
   * @returns
   */
  getListPoNumber(resourceId: number) {
    let params = new HttpParams();
    params = params.append('resourceId', resourceId);
    return this.http.get(`${environment.api_cm_receipts}/listPoNumber`, { params: params })
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  saveReceipts(param: any) {
    return this.http.post(`${environment.api_cm_receipts}/saveReceipts`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListReceipts(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_receipts}/listReceipts`, { params: params })
      .pipe(map(data => data));
  }

}
